import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import FunctionalCalendar from 'vue-functional-calendar'
import VueScrollTo from 'vue-scrollto'
import qs from 'qs'
import _ from 'lodash'
import { formatDate, getTodaysDate, formatToReadableDate, formatCalendarDate, formatToReadableCalendarDate } from './date-helpers'
import { checkEmail } from '../check-email'
import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

// Warn user about unsaved changes on navigation away:
function beforeUnload (e) {
  e.preventDefault()
  e.returnValue = ''
}

var registrationFormEl = document.getElementById('v-registration-form')
if (registrationFormEl) {
  window.addEventListener('beforeunload', beforeUnload)
}

// // Date picker defaults:
Vue.use(FunctionalCalendar)

// Animate page scroll:
Vue.use(VueScrollTo)

// For handling API data:
Vue.use(VueAxios, axios)

let path = window.location.pathname
path = path.substr(path.length - 1) === '/' ? path : path + '/'
export default Vue.component(
  'registration-form',
  {
    components: {
      ModelListSelect
    },
    data () {
      const dataset = registrationFormEl.dataset
      const workflow = registrationFormEl.dataset && registrationFormEl.dataset.workflow
      const clinic = registrationFormEl.dataset.clinic
      const isLitterRegistration = registrationFormEl.dataset.litter
      const litterId = registrationFormEl.dataset.litterId
      const addLittermate = false
      let originalData = {}
      let originalEmailData = {}
      let registeringID = ''
      let existingLitter = false

      if ((dataset && clinic && (workflow === 'enquirer-plus' || workflow === 'implanter'))) {
        registeringID = clinic
      }

      if ((dataset && clinic && workflow === 'guardian')) {
        registeringID = 0
      }

      if (isLitterRegistration && litterId) {
        existingLitter = true

        originalData = window.CANZPreviousAnimalDetails
        if (window.CANZContactDetails) {
          originalEmailData = window.CANZContactDetails
        }
      }
      return {
        isFull: (workflow !== 'implanter' && workflow !== 'enquirer-plus') || isLitterRegistration,
        isGuardian: workflow === 'guardian',
        loading: false,
        litterId: litterId,
        isLitterRegistration: isLitterRegistration,
        isNewRego: true,
        step: 1,
        showAddressDetails: false,
        guardianAccountStatus: 'unknown',
        breeds: window.CANZBreeds?.[originalData?.speciesId] || [],
        equidSpeciesIds: window.CANZEquidFormExtensionSpeciesIds || [],
        organisations: window.CANZOrganisations,
        vetClinics: window.CANZVetClinics,
        countries: window.CANZCountries,
        /*
         * Datepicker requires object for storing date values. Selected date is
         * extracted and converted into expected format on step submit (see below).
         */
        dateBornDateObject: {
          currentDate: '',
          selectedDate: '',
          selectedDateTime: false,
          selectedHour: '00',
          selectedMinute: '00',
          selectedDatesItem: '',
          selectedDates: [],
          dateRange: {
            start: '',
            end: ''
          },
          multipleDateRange: []
        },
        implantedDateObject: {
          currentDate: '',
          selectedDate: getTodaysDate(),
          selectedDateTime: false,
          selectedHour: '00',
          selectedMinute: '00',
          selectedDatesItem: '',
          selectedDates: [],
          dateRange: {
            start: '',
            end: ''
          },
          multipleDateRange: []
        },
        importedDateObject: {
          currentDate: '',
          selectedDate: '',
          selectedDateTime: false,
          selectedHour: '00',
          selectedMinute: '00',
          selectedDatesItem: '',
          selectedDates: [],
          dateRange: {
            start: '',
            end: ''
          },
          multipleDateRange: []
        },
        exportedDateObject: {
          currentDate: '',
          selectedDate: '',
          selectedDateTime: false,
          selectedHour: '00',
          selectedMinute: '00',
          selectedDatesItem: '',
          selectedDates: [],
          dateRange: {
            start: '',
            end: ''
          },
          multipleDateRange: []
        },
        implantMonth: '',
        implantYear: '',
        cardHolderName: '',
        fields: {
          FormToken: dataset && registrationFormEl.dataset.token,
          microchipNumber: '',
          microchipConfirm: '',
          companionName: '',
          breedPurity: existingLitter ? originalData.breedPurity : 'Unknown',
          gender: '',
          desexed: existingLitter ? originalData.desexed : '',
          dateBorn: '',
          speciesId: existingLitter ? originalData.speciesId : '',
          primaryBreedId: existingLitter ? originalData.primaryBreedId : '',
          secondaryBreedId: existingLitter ? originalData.secondaryBreedId : '',
          primaryColourId: '',
          secondaryColourId: '',
          colourDescription: '',
          StreetNumber: '',
          Street: '',
          Suburb: '',
          City: '',
          PostalCode: '',
          Region: '',
          Latitude: '',
          Longitude: '',
          notesGeneral: '',
          breederNotes: existingLitter ? originalData.breederNotes : '',
          importDate: '',
          exportDate: '',
          originCountry: '',
          brands: '',
          markings: '',
          agribaseIDNumber: '',
          equineStreetNumber: '',
          equineStreet: '',
          equineSuburb: '',
          equineCity: '',
          equinePostalCode: '',
          equineRegion: '',
          clinicId: existingLitter ? originalData.clinicId : ((dataset && clinic && workflow === 'implanter') ? clinic : ''),
          registeringClinicId: registeringID,
          dateImplanted: existingLitter ? originalData.dateImplanted : '',
          implanterName: existingLitter ? originalData.implanterName : '',
          registrationNumber: '',
          localAuthorityId: existingLitter ? originalData.localAuthorityId : '',
          guardianEmail: '',
          guardianMobileNumber: '',
          guardianAlternativeNumber: '',
          guardianFirstName: '',
          guardianSurname: '',
          guardianResidentialAddress: '',
          secondaryContactFirstName: '',
          secondaryContactSurname: '',
          secondaryContactMobileNumber: '',
          secondaryContactAlternativeNumber: '',
          stripeToken: '',
          paymentError: '',
          noEmailAvailable: existingLitter ? originalEmailData.noEmail : false,
          noEmailReason: '',
          organisationIsGuardian: existingLitter ? originalData.organisationIsGuardian : workflow === 'enquirer-plus'
        },
        formErrors: [],
        errors: {}
      }
    },
    created: function () {
      this.debouncedCheckEmail = _.debounce(this.checkEmail, 500)
    },
    computed: {
      isEquidSpecies () {
        return this.equidSpeciesIds.find(id => id == this.fields.speciesId)
      },
      formattedImplantDate () {
        return formatToReadableCalendarDate(this.implantedDateObject.selectedDate)
      },
      formattedBirthDate () {
        return formatToReadableCalendarDate(this.dateBornDateObject.selectedDate, true)
      },
      formattedImportDate () {
        return formatToReadableCalendarDate(this.importedDateObject.selectedDate, true)
      },
      formattedExportDate () {
        return formatToReadableCalendarDate(this.exportedDateObject.selectedDate, true)
      },
      equineDisplayAddress () {
        let address = ""
        if (this.fields.equineStreetNumber) {
          address = `${this.fields.equineStreetNumber}`
        }
        if (this.fields.equineStreet) {
          address = `${address} ${this.fields.equineStreet}`
        }
        if (this.fields.equineSuburb) {
          address = `${address}, ${this.fields.equineSuburb}`
        }
        if (this.fields.equineCity) {
          address = `${address}, ${this.fields.equineCity}`
        }
        if (this.fields.equinePostalCode) {
          address = `${address} ${this.fields.equinePostalCode}`
        }
        if (this.fields.equineRegion) {
          address = `${address}, ${this.fields.equineRegion}`
        }
        return address
      },
      calcValidationStep () {
        if (this.step === 1) {
          return 'Identification'
        } else if (this.step === 2) {
          return this.isFull ? 'Characteristics' : 'Implantation'
        } else if (this.step === 3) {
          return this.isFull ? 'Implantation' : 'GuardianOrPayment'
        } else {
          return 'GuardianOrPayment'
        }
      },
      totalSteps () {
        if (this.isLitterRegistration && this.litterId) {
          return 2
        }
        return this.isFull ? 4 : 3
      }
    },
    methods: {
      speciesChanged () {
        this.breeds = window.CANZBreeds?.[this.fields.speciesId] || []
      },
      clearEmailField () {
        if (!this.fields.noEmailAvailable) {
          this.fields.guardianEmail = ''
          delete this.errors.guardianEmail
        } else {
          this.fields.noEmailReason = ''
          delete this.errors.noEmailReason
        }
      },
      fullForm (value) {
        this.isFull = value
        if (!this.isFull && this.step > 1) {
          this.step -= 1
        }
      },
      submitStep (e, addAnotherLittermate = false) {
        e.preventDefault()

        this.addLittermate = addAnotherLittermate

        // Convert date format for datepicker fields
        this.fields.dateBorn = formatCalendarDate(this.dateBornDateObject.selectedDate)
        this.fields.dateImplanted = formatCalendarDate(this.implantedDateObject.selectedDate)
        this.fields.importDate = formatCalendarDate(this.importedDateObject.selectedDate)
        this.fields.exportDate = formatCalendarDate(this.exportedDateObject.selectedDate)

        this.formErrors = []
        this.errors = {}
        this.loading = true

        if (this.step === this.totalSteps && this.isGuardian) {
          if (!window.CANZ?.stripeKey) {
            return
          }
          const errors = _.clone(this.errors)
          if (this.cardHolderName.length <= 0) {
            errors.cardHolderName = {
              code: 'card-holder-error',
              type: 'error',
              value: 'Card holder name required'
            }
            this.errors = errors
          }
          this.stripe.createToken(this.card, { name: this.cardHolderName }).then((result) => {
            if (result.error) {
              const errors = _.clone(this.errors)
              errors.paymentError = {
                code: 'token-validation-error',
                type: 'error',
                value: result.error?.message
              }
              this.errors = errors
              this.loading = false
            } else {
              // Send the token to your server.
              if (this.cardHolderName.length <= 0) {
                this.loading = false
                return
              }
              this.fields.stripeToken = result.token.id
              this.doPost()
            }
          })
        } else {
          this.doPost()
        }
      },
      doPost (e) {
        let url = this.step === this.totalSteps ? path + 'submit' : path + 'validate'
        if (this.litterId) {
          url = `${url}?id=${this.litterId}`
        }
        this.axios({
          method: 'POST',
          url,
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: qs.stringify({
            ...this.fields,
            step: this.calcValidationStep,
            isNewRego: this.isNewRego,
            addLittermate: this.addLittermate
          }),
          maxRedirects: 0
        }).then((response) => {
          if (response?.data?.status === 'success') {
            if (this.step === this.totalSteps) {
              window.removeEventListener('beforeunload', beforeUnload)

              if (response?.data?.litterId) {
                window.location = '/implanter/dashboard/register/litter?id=' + response?.data?.litterId
              } else {
                window.location = this.isGuardian ? '/my-companion-animals/?active=1' : '/implanter/dashboard/?s=' + this.fields.microchipNumber
              }
            } else {
              this.loading = false
              this.step += 1
            }
          } else {
            this.handleErrors({ response })
          }
        }).catch(this.handleErrors)
      },
      handleErrors (error) {
        this.loading = false
        const errors = {}
        const addressFields = ['StreetNumber', 'Street', 'Suburb', 'Region', 'PostalCode']
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors || {}).forEach((k) => {
            if (typeof this.fields[k] !== 'undefined') {
              if (addressFields.includes(k)) {
                this.showAddressDetails = true
              }
              errors[k] = error.response.data.errors[k]
            } else {
              this.formErrors.push(error.response.data.errors[k])
            }
          })
        } else {
          this.formErrors.push({
            value: 'An unknown error has occurred, please try again, or copy your data and reload the page'
          })
        }
        this.errors = errors

        // Once errors displayed, scroll window to first instance within current step
        this.$nextTick(() => {
          const curStepCard = document.getElementById('v-' + this.calcValidationStep + '-inputs')

          let errorElements = curStepCard?.getElementsByClassName('c-form-field__message--error')
          if (!errorElements?.length) {
            errorElements = document.getElementsByClassName('c-message--error')
          }
          if (errorElements?.length) {
            VueScrollTo.scrollTo(errorElements[0], 400, {
              offset: -75
            })
          }
        })
      },
      checkEmail,
      getTodaysDate
    },
    mounted () {
      if (!window.CANZ?.stripeKey) {
        return
      }
      this.stripe = window.Stripe(window.CANZ.stripeKey)
      const elements = this.stripe.elements()
      // Custom styling can be passed to options when creating an Element.
      const style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '12px',
          color: '#32325d'
        }
      }

      // Create an instance of the card Element.
      this.card = elements.create('card', { hidePostalCode: true, style })

      // Add an instance of the card Element into the `card-element` <div>.
      this.card.mount('#card-element')
    }
  }
)
